import axios from "../../lib/axios";

export async function addSelectedItem(closetId, variant_id) {
  const path = `users/closets/${closetId}/customize/selected_item`;
  const res = await axios.post(path, { selected_item: { variant_id } });
  return res.data.data;
}

export async function putSelectedItem(closetId, selectedItemId, variant_id) {
  const path = `users/closets/${closetId}/customize/selected_item/${selectedItemId}`;
  const res = await axios.put(path, { selected_item: { variant_id } });
  return res.data.data;
}

export async function removeSelectedItem(closetId, selectedItemId) {
  const path = `users/closets/${closetId}/customize/selected_item/${selectedItemId}`;
  const res = await axios.delete(path);
  return res.data.data;
}

export async function validateCloset(closetId) {
  const path = `users/closets/customize/${closetId}`;
  const res = await axios.put(path);
  return res.data.data;
}
